import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthModule } from '@core/auth/auth.module';
import { HttpErrorInterceptor } from '@core/http-interceptors/http-error.interceptor';
import { HttpNoContentInterceptor } from '@core/http-interceptors/http-no-content.interceptor';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '@shared/shared.module';
import packageJson from '../../../package.json';
import { AuthGuardService } from './auth/auth-guard.service';
import { authLogin, authLogout } from './auth/store/auth.actions';
import { AuthEffects } from './auth/store/auth.effects';
import { selectAuth, selectIsAuthenticated } from './auth/store/auth.selectors';
import { AppState, reducers } from './core.state';

const version = packageJson.version;

export { selectAuth, authLogin, authLogout, AppState, selectIsAuthenticated, AuthGuardService };

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cacheBuster=' + version);
}

@NgModule({
  imports: [
    HttpClientModule,
    SharedModule,
    AuthModule,

    // ngrx
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([AuthEffects]),

    StoreDevtoolsModule.instrument({
      name: 'UI Workspace analytics',
      maxAge: 100,
      logOnly: false,
      features: {
        export: true,
        import: 'custom',
        jump: true,
        dispatch: true,
        lock: true,
        pause: true,
        persist: true,
        reorder: true,
        skip: true,
        test: true
      }
    }),

    // 3rd party
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpNoContentInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
